webpackJsonp([1],Array(27).concat([
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);




function getUser() {
  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var req = fetch("/api/me", { credentials: "include" });
    req.then(function (response) {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch(function (error) {
      reject(error);
    });
  });
  return prom;
}

function getNote(date) {
  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var req = fetch("/api/note/" + date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + "/", { credentials: "include" });
    req.then(function (response) {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch(function (error) {
      reject(error);
    });
  });
  return prom;
}

function saveNote(note) {
  var date = new Date(note.date);
  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var req = fetch("/api/note/" + date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + "/", { method: "POST",
      body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(note),
      headers: { "Content-Type": "application/json" },
      credentials: "include" });
    req.then(function (response) {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch(function (error) {
      reject(error);
    });
  });
  return prom;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: getUser,
  getNote: getNote,
  saveNote: saveNote
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(109)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NotePage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NotePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NotePage__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "HomePage",
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage___default.a
  }, {
    path: "/note/:yearParam/:monthParam/:dateParam",
    name: "NotePage",
    component: __WEBPACK_IMPORTED_MODULE_3__components_NotePage___default.a,
    props: true
  }],
  mode: "history"
}));

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selectDate: function selectDate(_ref) {
      var year = _ref.year,
          month = _ref.month,
          date = _ref.date;

      this.toggleCalendar();
      this.updateDate({ year: year, month: month, date: date });
      __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ name: "NotePage", params: { yearParam: year, monthParam: month, dateParam: date } });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(["updateMonthYear", "updateDate", "toggleCalendar"]))
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(101)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calendar__ = __webpack_require__(51);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    isCalendarVisible: false,
    appTitle: __WEBPACK_IMPORTED_MODULE_2__conf__["a" /* appTitle */]
  },
  mutations: {
    toggleCalendar: function toggleCalendar(state) {
      state.isCalendarVisible = !state.isCalendarVisible;
    }
  },
  getters: {
    appTitle: function appTitle(state) {
      return state.appTitle;
    },
    isCalendarVisible: function isCalendarVisible(state) {
      return state.isCalendarVisible;
    }
  },
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_4__calendar__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)
__webpack_require__(104)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appTitle; });
/* unused harmony export version */
var appTitle = "Note for the Day";
var version = 0.1;



/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(47);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  },
  created: function created() {}
});

__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUser().then(function (response) {
  app.$store.commit({
    type: "loginUser",
    user: response
  });
}).catch(function (error) {
  app.$store.commit({
    type: "loginUser",
    user: false
  });
  console.log("error", error);
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    year: null,
    month: null,
    date: null
  },
  mutations: {
    updateMonthYear: function updateMonthYear(state, _ref) {
      var year = _ref.year,
          month = _ref.month;

      if (month !== null) {
        state.month = month;
      }
      if (year !== null) {
        state.year = year;
      }
    },
    updateDate: function updateDate(state, _ref2) {
      var year = _ref2.year,
          month = _ref2.month,
          date = _ref2.date;

      state.date = {
        year: year,
        month: month,
        date: date
      };
    }
  },
  getters: {
    year: function year(state) {
      return state.year;
    },
    month: function month(state) {
      return state.month;
    },
    date: function date(state) {
      return state.date;
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    loginUser: function loginUser(state, data) {
      state.user = data.user;
    },
    logoutUser: function logoutUser(state) {
      state.user = null;
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginPage__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LoginPage__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["user", "appTitle", "loading"])),
  components: {
    LoginPage: __WEBPACK_IMPORTED_MODULE_3__components_LoginPage___default.a,
    PulseLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader___default.a
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var today = new Date();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "calendar",
  data: function data() {
    return {
      days: days,
      months: months
    };
  },

  computed: {
    title: function title() {
      return months[this.month - 1] + " " + this.year;
    },

    monthInput: {
      get: function get() {
        return this.month;
      },
      set: function set(month) {
        this.$emit("updateMonthYear", { year: this.year, month: month });
      }
    },
    yearInput: {
      get: function get() {
        return this.year;
      },
      set: function set(year) {
        this.$emit("updateMonthYear", { year: year, month: this.month });
      }
    },
    calendarWeeks: function calendarWeeks() {
      var weeks = [];
      var year = this.year;
      var month = this.month;
      var startDate = new Date(year, month - 1, 1);
      var endDate = new Date(year, month, 0);
      var week = [];
      var i = void 0;
      var dayCounter = 0;

      for (i = 0; i < startDate.getDay(); i += 1) {
        week.push(null);
        dayCounter += 1;
      }

      for (i = startDate.getDate(); i <= endDate.getDate(); i += 1) {
        dayCounter += 1;
        week.push(i);
        if (dayCounter % 7 === 0) {
          weeks.push(week);
          week = [];
        }
      }
      if (week.length > 0) {
        if (week.length < 7) {
          for (i = week.length; i < 7; i += 1) {
            week.push(null);
          }
        }
        weeks.push(week);
      }

      return weeks;
    }
  },
  props: {
    year: {
      type: Number,
      default: today.getFullYear()
    },
    month: {
      type: Number,
      default: today.getMonth() + 1
    }
  },
  methods: {
    prevMonth: function prevMonth() {
      var month = this.month;
      var year = this.year;
      month -= 1;
      if (month < 1) {
        month = 12;
        year -= 1;
      }
      this.$emit("updateMonthYear", { year: year, month: month });
    },
    nextMonth: function nextMonth() {
      var month = this.month;
      var year = this.year;
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
      this.$emit("updateMonthYear", { year: year, month: month });
    },
    selectDate: function selectDate(date) {
      this.$emit("selectDate", { year: this.year, month: this.month, date: date });
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "header",
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["user", "isCalendarVisible", "appTitle"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(["toggleCalendar"]))
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Note__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Calendar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_calendar__ = __webpack_require__(29);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["user", "isCalendarVisible", "month", "year", "date"])),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_calendar__["a" /* default */]],
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header___default.a,
    Note: __WEBPACK_IMPORTED_MODULE_3__components_Note___default.a,
    Calendar: __WEBPACK_IMPORTED_MODULE_4__components_Calendar___default.a
  },
  created: function created() {
    var today = new Date();
    this.updateMonthYear({ year: today.getFullYear(), month: today.getMonth() + 1 });
    this.updateDate({ year: today.getFullYear(),
      month: today.getMonth() + 1,
      date: today.getDate() });
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["appTitle", "loading"]))
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "note",
  data: function data() {
    return {
      note: null,
      message: {
        text: null,
        type: ""
      }
    };
  },

  props: {
    year: {
      type: Number
    },
    month: {
      type: Number
    },
    date: {
      type: Number
    }
  },
  computed: {
    title: function title() {
      return "" + this.dateObj.toDateString();
    },
    dateObj: function dateObj() {
      var note = this;
      return new Date(note.year, note.month - 1, note.date);
    }
  },
  watch: {
    year: function year() {
      this.getNote();
    },
    month: function month() {
      this.getNote();
    },
    date: function date() {
      this.getNote();
    }
  },
  methods: {
    saveNote: function saveNote() {
      var note = this;
      note.flashMessage("Saving...", "success");
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveNote(this.note).then(function (response) {
        console.log("Note saved", response);
        note.flashMessage("Note saved 👍", "success");
      }).catch(function (error) {
        console.log("Note save failed", error);
        note.flashMessage("Failed to save. 😞", "error");
      });
    },
    getNote: function getNote() {
      var note = this;
      note.note = null;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getNote(this.dateObj).then(function (response) {
        note.note = response;
      });
    },
    flashMessage: function flashMessage(text, type) {
      var note = this;
      note.message = { text: text, type: type };
      setTimeout(function () {
        note.message = { text: null, type: null };
      }, 3000);
    }
  },
  created: function created() {
    this.getNote();
  },

  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader___default.a
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Calendar__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Note__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_calendar__ = __webpack_require__(29);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "note-page",
  data: function data() {
    return {};
  },

  props: ["yearParam", "monthParam", "dateParam"],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    year: function year() {
      return Number(this.yearParam);
    },
    month: function month() {
      return Number(this.monthParam);
    },
    date: function date() {
      return Number(this.dateParam);
    },
    title: function title() {
      return this.year + " - " + this.month + " - " + this.date;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["user", "isCalendarVisible"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    calendarMonth: "month",
    calendarYear: "year"
  })),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_calendar__["a" /* default */]],
  created: function created() {
    this.updateMonthYear({ year: this.year, month: this.month });
    this.updateDate({ year: this.year,
      month: this.month,
      date: this.date });
  },

  components: {
    Note: __WEBPACK_IMPORTED_MODULE_4__components_Note___default.a,
    appHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header___default.a,
    Calendar: __WEBPACK_IMPORTED_MODULE_3__components_Calendar___default.a
  }
});

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-47fa6252",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-md-5-6 pure-u-lg-3-4 pure-u-xl-2-3 container"
  }, [_c('app-header'), _vm._v(" "), (_vm.isCalendarVisible) ? _c('Calendar', {
    attrs: {
      "year": _vm.year,
      "month": _vm.month
    },
    on: {
      "updateMonthYear": _vm.updateMonthYear,
      "selectDate": _vm.selectDate
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('Note', {
    staticClass: "pure-u-1",
    attrs: {
      "year": _vm.date.year,
      "month": _vm.date.month,
      "date": _vm.date.date
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note"
  }, [_c('h2', {
    staticClass: "note__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.note) ? _c('PulseLoader', {
    staticClass: "loading-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('form', {
    staticClass: "note__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveNote($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    staticClass: "note__editor",
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note__bar"
  }, [_c('span', {
    staticClass: "note__message",
    class: _vm.message.type
  }, [_vm._v(_vm._s(_vm.message.text))]), _vm._v(" "), _c('input', {
    staticClass: "note__submit pure-button",
    attrs: {
      "type": "submit",
      "value": "Save"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g",
    attrs: {
      "id": "app"
    }
  }, [(_vm.user === null) ? _c('PulseLoader', {
    staticClass: "loading-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.user === false) ? _c('LoginPage') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-menu pure-menu-horizontal header"
  }, [_c('h1', {
    staticClass: "pure-menu-heading header__title"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.appTitle))])]), _vm._v(" "), _c('ul', {
    staticClass: " pure-menu-list header__menu-links"
  }, [(_vm.user) ? _c('li', {
    staticClass: "pure-menu-item",
    class: {
      'pure-menu-selected': _vm.isCalendarVisible
    }
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "title": "Calendar"
    },
    on: {
      "click": _vm.toggleCalendar
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [(_vm.user) ? _c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "/logout",
      "title": "Logout"
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-md-5-6 pure-u-lg-3-4 pure-u-xl-2-3 container"
  }, [_c('app-header'), _vm._v(" "), (_vm.isCalendarVisible) ? _c('Calendar', {
    attrs: {
      "year": _vm.calendarYear,
      "month": _vm.calendarMonth
    },
    on: {
      "updateMonthYear": _vm.updateMonthYear,
      "selectDate": _vm.selectDate
    }
  }) : _vm._e(), _vm._v(" "), _c('Note', {
    attrs: {
      "year": _vm.year,
      "month": _vm.month,
      "date": _vm.date
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-4-5 login-container l-box"
  }, [_c('h1', [_vm._v(_vm._s(_vm.appTitle))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Make daily notes.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "pure-button login-button",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login to start")])])])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "calendar__controls pure-g"
  }, [_c('span', {
    staticClass: "pure-u-1-5"
  }, [_c('a', {
    staticClass: "calendar__prev pure-button calendar__nav-button",
    attrs: {
      "title": "Previous Month"
    },
    on: {
      "click": _vm.prevMonth
    }
  }, [_c('i', {
    staticClass: "icon-angle-left"
  })])]), _vm._v(" "), _c('form', {
    staticClass: "pure-form controls__form pure-u-3-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.monthInput),
      expression: "monthInput",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "controls__form__month",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.monthInput = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.months), function(month, index) {
    return _c('option', {
      domProps: {
        "value": (index + 1)
      }
    }, [_vm._v(_vm._s(month))])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.yearInput),
      expression: "yearInput",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "controls__form__year",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.yearInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yearInput = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pure-u-1-5"
  }, [_c('a', {
    staticClass: "calendar__next pure-button calendar__nav-button",
    attrs: {
      "title": "Next Month"
    },
    on: {
      "click": _vm.nextMonth
    }
  }, [_c('i', {
    staticClass: "icon-angle-right"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "calendar__table pure-table pure-table-bordered",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('caption', {
    staticClass: "calendar__table__caption"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('thead', _vm._l((_vm.days), function(day) {
    return _c('th', {
      staticClass: "cell-header"
    }, [_vm._v(_vm._s(day))])
  })), _vm._v(" "), _c('tbody', _vm._l((_vm.calendarWeeks), function(week) {
    return _c('tr', _vm._l((week), function(dateParam) {
      return _c('td', {
        staticClass: "calendar__day"
      }, [(dateParam) ? _c('a', {
        on: {
          "click": function($event) {
            _vm.selectDate(dateParam)
          }
        }
      }, [_vm._v(_vm._s(dateParam))]) : _vm._e()])
    }))
  }))])])
},staticRenderFns: []}

/***/ })
]),[50]);


// WEBPACK FOOTER //
// js/app.504f89e824ad1ec3d489.js